import { render, staticRenderFns } from "./OccurrenceTeamRequests.vue?vue&type=template&id=d987b980&scoped=true&"
import script from "./OccurrenceTeamRequests.vue?vue&type=script&lang=js&"
export * from "./OccurrenceTeamRequests.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceTeamRequests.vue?vue&type=style&index=0&id=d987b980&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d987b980",
  null
  
)

export default component.exports